import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "productUpdates",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "product-updates" */ "./components"),
      import(
        /* webpackChunkName: "product-updates" */ "./modules/ProductUpdatesV2Modules"
      ),
    ])
      .then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const productUpdateModule = importedModule1;
        injectReducer(store, {
          key: "productUpdatesV2",
          reducer: productUpdateModule.default,
        });
        return component;
      })
      .catch(err => {
        console.error("Failed to load product updates modules:", err);
        throw err;
      })
  ),
});
